import type { Except } from "type-fest";
import { z } from "zod";
import type {
    ResourceScheduleId} from "./resource-schedule-id";
import {
    resourceScheduleIdFactory,
    resourceScheduleIdZodSchema,
} from "./resource-schedule-id";
import type {
    ResourceScheduleInterval} from "./resource-schedule-interval";
import {
    resourceScheduleIntervalZodSchema,
} from "./resource-schedule-interval";

type ResourceSchedule = {
    _id: string;
    _type: "RESOURCE_SCHEDULE";
    intervals: ResourceScheduleInterval[];
};

const resourceScheduleFactory = (
    params: Except<ResourceSchedule, "_id" | "_type"> & {
        _id?: ResourceScheduleId;
    },
): ResourceSchedule => {
    return {
        ...params,
        _id: params._id ?? resourceScheduleIdFactory(),
        _type: "RESOURCE_SCHEDULE",
    };
};

const resourceScheduleZodSchema: z.ZodSchema<ResourceSchedule> = z.object({
    _id: resourceScheduleIdZodSchema,
    _type: z.literal("RESOURCE_SCHEDULE"),
    intervals: z.array(resourceScheduleIntervalZodSchema),
});

export { resourceScheduleFactory, resourceScheduleZodSchema };
export type { ResourceSchedule };
